export default __webpack_public_path__ + "static/media/mstreets.686bac18.jpg";